import React, { ReactElement } from 'react';
import { View, ViewStyle } from 'react-native';

import KitIcon, { KitIconProps } from './KitIcon';

interface KitIconCircleProps extends KitIconProps {
  circleSize: number;
  backgroundColor: string;
  circleStyle?: ViewStyle;
}

// deprecated: use KitContainedIcon instead
function KitIconCircle(props: KitIconCircleProps): ReactElement {
  const { backgroundColor, circleSize, circleStyle } = props;

  return (
    <View
      style={[
        {
          alignItems: 'center',
          backgroundColor,
          borderRadius: 1000,
          height: circleSize,
          justifyContent: 'center',
          padding: circleSize / 4,
          width: circleSize,
        },
        circleStyle,
      ]}
    >
      <KitIcon {...props} />
    </View>
  );
}
export default KitIconCircle;
